export const FIND_BUTTON_DEFAULT_TEXT = 'CUSTOM SIZE RESULTS'
